import { produce } from 'immer';

import { invitationActionTypes } from './invitation.types';

const initialState = {
    // Invitation details returned by the verify endpoint.
    // Expected shape: { workspaceName, inviterName, inviterEmail, invitedEmail, ... }
    data: null,

    isLoading: false,
    error: null,

    // 'success' | 'error' | null
    acceptStatus: null,
};

const invitationReducer = (state = initialState, action) => {
    return produce(state, (draft) => {
        switch (action.type) {

            // VERIFY
            case invitationActionTypes.INVITATION_VERIFY_REQUEST: {
                draft.isLoading = true;
                draft.error = null;
                draft.data = null;
                break;
            }
            case invitationActionTypes.INVITATION_VERIFY_SUCCESS: {
                draft.data = action.payload;
                draft.isLoading = false;
                draft.error = null;
                break;
            }
            case invitationActionTypes.INVITATION_VERIFY_FAILURE: {
                draft.isLoading = false;
                draft.error = action.payload;
                break;
            }

            // ACCEPT
            case invitationActionTypes.INVITATION_ACCEPT_REQUEST: {
                draft.isLoading = true;
                draft.acceptStatus = null;
                break;
            }
            case invitationActionTypes.INVITATION_ACCEPT_SUCCESS: {
                draft.isLoading = false;
                draft.acceptStatus = 'success';
                break;
            }
            case invitationActionTypes.INVITATION_ACCEPT_FAILURE: {
                draft.isLoading = false;
                draft.acceptStatus = 'error';
                draft.error = action.payload;
                break;
            }

            // RESET
            case invitationActionTypes.INVITATION_RESET: {
                return initialState;
            }

            default:
                break;
        }
    });
};

export default invitationReducer;
